import { createReducer } from '@reduxjs/toolkit'

export const authReducer = createReducer({}, builder => {
  builder.addCase('LOGIN', (state, action) => {
    // @todo
  })
})
